import { openDB } from 'idb';

const DB_NAME = 'AppDatabase';
const DB_VERSION = 2;
const PERMISOS_STORE = 'PermisosPaginas';
const MUNICIPIOS_DX_STORE = 'MunicipiosDX';
const MUNICIPIOS_CARACT_STORE = 'MunicipiosCaract';

export async function initDB() {
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(PERMISOS_STORE)) {
                db.createObjectStore(PERMISOS_STORE, { keyPath: 'id' });
            }

            if (!db.objectStoreNames.contains(MUNICIPIOS_DX_STORE)) {
                db.createObjectStore(MUNICIPIOS_DX_STORE, { keyPath: 'id' });
            }

            if (!db.objectStoreNames.contains(MUNICIPIOS_CARACT_STORE)) {
                db.createObjectStore(MUNICIPIOS_CARACT_STORE, { keyPath: 'id' });
            }
        },
    });
}

export async function savePermisosPaginas(permisos) {
    const db = await initDB();
    const tx = db.transaction(PERMISOS_STORE, 'readwrite');
    await tx.store.put({ id: 'data', data: permisos });
    await tx.done;
}

export async function getPermisosPaginas() {
    const db = await initDB();
    const tx = db.transaction(PERMISOS_STORE, 'readonly');
    let result = await tx.store.get('data');

    if (!result) {
        result = await tx.store.get('permisos');
    }

    return result ? result.data : null;
}

export async function saveMunicipiosDX(municipios) {
    const db = await initDB();
    const tx = db.transaction(MUNICIPIOS_DX_STORE, 'readwrite');
    await tx.store.put({ id: 'data', data: municipios });
    await tx.done;
}

export async function getMunicipiosDX() {
    const db = await initDB();
    const tx = db.transaction(MUNICIPIOS_DX_STORE, 'readonly');
    let result = await tx.store.get('data');

    if (!result && db.objectStoreNames.contains(PERMISOS_STORE)) {
        const legacyTx = db.transaction(PERMISOS_STORE, 'readonly');
        result = await legacyTx.store.get('municipiosdx');
    }

    return result ? result.data : null;
}

export async function saveMunicipiosCaract(municipios) {
    const db = await initDB();
    const tx = db.transaction(MUNICIPIOS_CARACT_STORE, 'readwrite');
    await tx.store.put({ id: 'data', data: municipios });
    await tx.done;
}

export async function getMunicipiosCaract() {
    const db = await initDB();
    const tx = db.transaction(MUNICIPIOS_CARACT_STORE, 'readonly');
    let result = await tx.store.get('data');

    if (!result && db.objectStoreNames.contains(PERMISOS_STORE)) {
        const legacyTx = db.transaction(PERMISOS_STORE, 'readonly');
        result = await legacyTx.store.get('municipioscaract');
    }

    return result ? result.data : null;
}